<h2>Отыгрыши</h2>

<div class="container">
  <div class="ref-income-container">

    <div class="ref-income-above-table-container">
      <button mat-stroked-button color="primary" (click)="createPayback()">Создать
      </button>
      <!--    <div class="smart-prices-filter-container">-->
      <!--      <form [formGroup]="verificationsForm" class="verifications-search-form">-->

      <!--        <mat-form-field class="mat-form-field form-field mat-button-custom" appearance="outline" >-->
      <!--          <mat-label>User ID</mat-label>-->
      <!--          <input matInput formControlName="userId" type="number" placeholder="user id" class="no-arrows">-->
      <!--          <button *ngIf="verificationsForm.get('userId')?.value" matSuffix mat-icon-button aria-label="Clear"-->
      <!--                  (click)="verificationsForm.get('userId')?.reset()">-->
      <!--            <mat-icon>close</mat-icon>-->
      <!--          </button>-->
      <!--        </mat-form-field>-->

      <!--        &lt;!&ndash;        class="mat-type-select"&ndash;&gt;-->
      <!--        <mat-form-field appearance="outline" class="mat-form-field">-->
      <!--          <mat-label>Status</mat-label>-->
      <!--          <mat-select formControlName="statuses" multiple panelClass="recent-operation-select-panel"-->
      <!--                      placeholder="Statuses">-->
      <!--            <div class="mat-select-list">-->
      <!--              <mat-option *ngFor="let status of statusList" [value]="status">{{ status }}</mat-option>-->
      <!--            </div>-->

      <!--          </mat-select>-->
      <!--        </mat-form-field>-->

      <!--        <button mat-stroked-button color="primary" (click)="search()" class="search-btn">Search</button>-->

      <!--      </form>-->
      <!--    </div>-->
    </div>

    <div class="ref-income-table-container">
      <div class="table-wrapper table-density">
        <div class="table-loading" *ngIf="paybackSource.isLoading$ | async">
          <mat-spinner diameter="20" style="margin: 0 auto"></mat-spinner>
        </div>
        <table mat-table [dataSource]="paybackSource" class="table ref-income-table" matSort>

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let element">
              <span class="ellipsis-text">{{ element.id }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="payback">
            <th mat-header-cell *matHeaderCellDef>Payback</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ (element.payback / 100) | number : '1.2-5' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.type }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actionType">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.actionType }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="lockType">
            <th mat-header-cell *matHeaderCellDef>Lock type</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.lockType }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.createdAt | date: 'dd.MM.yy HH:mm:ss' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group controls">
                <button class="btn btn-sm btn-success"
                        (click)="updatePayback(element)">Update
                </button>
              </div>
            </td>
          </ng-container>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="paybackColumns.length">
            </td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="paybackColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: paybackColumns;"></tr>
        </table>
      </div>
      <mat-paginator [length]="paybackSource.totalCount"
                     [pageSizeOptions]="[500]">
      </mat-paginator>
    </div>
  </div>

  <h2>Валютный отыгрыш</h2>

  <div class="ref-income-container">
    <div class="ref-income-table-container">
      <div class="table-wrapper table-density">
        <div class="table-loading" *ngIf="paybackWalletsLoading">
          <mat-spinner diameter="20" style="margin: 0 auto"></mat-spinner>
        </div>
        <table mat-table [dataSource]="paybackWalletRows" class="table ref-income-table">

          <ng-container matColumnDef="walletType">
            <th mat-header-cell *matHeaderCellDef>Wallet type</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.walletType }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="payback">
            <th mat-header-cell *matHeaderCellDef>Payback</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ (element.payback / 100) | number : '1.3-3' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group controls">
                <button class="btn btn-sm btn-success"
                        (click)="updatePaybackWallet(element)">Update
                </button>
              </div>
            </td>
          </ng-container>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="paybackWalletColumns.length">
              Нет кошельков
            </td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="paybackWalletColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: paybackWalletColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
